import { Paper, InputBase, Divider, Slider } from "@mui/material";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { isEmpty } from "lodash";
import { userCoinBalance } from "../../../actions/user";
import { num2English, showPrice } from "../../../utils/priceFunc";
import { showBetterPrice } from "../../../utils/showBetterPrice";
import { usersMakeChangeOrders } from "../../../services/adminServices";
import { getCoinDetail } from "../../../actions/getCoinDetail";
import { LoadingPage } from "../../LoadingPage/LoadingPage";
import { errorMessage, successMessage } from "../../../utils/messages";
//Components
import CoinList from "../CoinList/CoinList";
//Styles and Icons
import styles from "./Convert.module.scss";
import CartIcon from "../../../styles/icon/carticon.svg";
import ArrowFillIcon from "../../../styles/icon/ArrowFillDown.svg";
import SwitchIcon from "../../../styles/icon/switchgreen.svg";
import EqualIcon from "../../../styles/icon/equal.svg";
import MiniChartIcon from "../../../styles/icon/minichart.svg";
import WarningRedIcon from "../../../styles/icon/warningRed.svg";
import { getCoinList, getRateOfCoins } from "../../../services/marketServices";
import {
  hiddenLoadingPage,
  showLoadingPage,
} from "../../../actions/loadingPage";
export default function Convert() {
  const LoadingBar = useSelector((state) => state.loadingBar.loading);
  const marketCoinsList = useSelector((state) => state.market?.data);
  const GET_COIN_INFO = useSelector((state) => state.coinInfo.data);
  const userId = useSelector((state) => state.userId);
  const coinOfUser = useSelector(
    (state) => state.fullUserInfo?.coinBalance?.asset
  );
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [rateValue, setRateValue] = useState(0);
  const [conListVisible, setCoinListVisible] = useState(false);
  const [forWhich, setForWhich] = useState(0);
  //State's
  const [payCoin, setPayCoin] = useState({});
  const [getCoin, setGetCoin] = useState({});
  let [orderAmount, setOrderAmount] = useState(0);
  //End State's
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search);
  let term = queryParams.get("coin");

  useEffect(() => {
    let mounted = true;
    // ----->
    const getListsTerm = (value) => {
      setPayCoin(value.filter((d) => d.symbol === term)[0]);
      setGetCoin(value.filter((d) => d.symbol !== term)[0]);
    };
    const getListsRandom = (value) => {
      const firstCoin = value[0];
      setPayCoin(firstCoin);
      setGetCoin(value.filter((d) => d.symbol !== firstCoin.symbol)[0]);
    };
    // ----->
    if (term && mounted) {
      if (isEmpty(marketCoinsList)) {
        (async () => {
          dispatch(showLoadingPage());
          const { data } = await getCoinList();
          getListsTerm(data.data);
          dispatch(hiddenLoadingPage());
        })();
      } else {
        getListsTerm(marketCoinsList);
      }
    } else {
      if (isEmpty(marketCoinsList)) {
        if (mounted) {
          (async () => {
            dispatch(showLoadingPage());
            const { data } = await getCoinList();
            getListsRandom(data.data);
            dispatch(hiddenLoadingPage());
          })();
        }
      } else {
        getListsRandom(marketCoinsList);
      }
    }
    return () => (mounted = false);
  }, []);
  //
  useEffect(() => {
    let mounted = true;
    if (mounted && payCoin.symbol)
      (async () => {
        dispatch(userCoinBalance(payCoin.symbol));
      })();
    ///////
    if (mounted && payCoin.symbol && getCoin.symbol) {
      (async () => {
        const { data } = await getRateOfCoins(payCoin.symbol, getCoin.symbol);
        setRateValue(data.data.rate);
        dispatch(getCoinDetail(getCoin.symbol));
      })();
    }
    return () => (mounted = false);
  }, [payCoin, getCoin]);
  //
  //SWAP
  const changePayGet = () => {
    let pay = { ...payCoin };
    let get = { ...getCoin };
    setPayCoin(get);
    setGetCoin(pay);
  };
  const setUserBalanceValue = (e) => {
    let userCoin = 0;
    let percent = e.target.value * 0.01;
    userCoin = Number(coinOfUser?.balance - coinOfUser?.locked) || 0;
    setOrderAmount(userCoin * percent);
  };

  //Handle send data to sever
  const handleMakeOrders = async () => {
    if (!+orderAmount) return errorMessage("تعداد به درستی وارد نشده");
    if (+orderAmount * rateValue < GET_COIN_INFO.minAmount)
      return errorMessage("حداقل مقدار تبدیل رعایت نشده است");
    if (+orderAmount > Number(coinOfUser?.balance - coinOfUser?.locked) || 0)
      return errorMessage("موجودی حساب شما کافی نمیباشد");
    orderAmount = +orderAmount;
    setDisabledBtn(true);
    let options = {
      market: `${payCoin.symbol}-${getCoin.symbol}`,
      orderAmount,
      orderType: "change",
    };
    try {
      const { data } = await usersMakeChangeOrders(options);
      if (data.error) {
        errorMessage(data.error);
      } else {
        setOrderAmount(0);
        dispatch(userCoinBalance(payCoin.symbol));
        successMessage(data.message);
      }
    } catch {
      errorMessage("مشکلی پیش آمده دوباره تلاش کنید");
    } finally {
      setDisabledBtn(false);
    }
  };
  const history = useHistory();
  return (
    <>
      {LoadingBar && <LoadingPage />}
      {conListVisible && (
        <CoinList
          visible={conListVisible}
          setVisible={setCoinListVisible}
          currentCoin={forWhich ? getCoin : payCoin}
          setCurrentCoin={forWhich ? setGetCoin : setPayCoin}
          currentTwoCoin={forWhich ? payCoin : getCoin}
        />
      )}
      <div className={`${styles.container} convert_basic`}>
        <header className={styles.buttons_swap_components}>
          <Link to="/convert-custom">
            <div className={`${styles.button_of_swap}`}>قیمت دلخواه</div>
          </Link>
          <Link to="/convert">
            <div
              className={`${styles.button_of_swap} ${styles.active_button_swap}`}
            >
              تبدیل
            </div>
          </Link>
        </header>
        <main className={styles.information_of_convert_container}>
          <div className={styles.pay_coin_information}>
            <div className={`changeTextColorToGreen ${styles.deposit_coin}`}>
              <div onClick={() => history.push(`/deposit/${payCoin?.symbol}`)}>
                واریز
                <img
                  src={CartIcon}
                  width={22}
                  height={22}
                  alt="cart"
                  className="convertPicToGreen"
                />
              </div>
            </div>
            <div className={`changeBackgroundToWhite ${styles.input_place}`}>
              <Paper
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  value={orderAmount}
                  onChange={(e) => setOrderAmount(num2English(e.target.value))}
                />
                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                <div
                  className={styles.box_coin_select}
                  onClick={() => {
                    !disabledBtn && setCoinListVisible(true);
                    setForWhich(0);
                  }}
                >
                  <div className={styles.ArrowPlace}>
                    <img
                      className={styles.forAnim_arrow}
                      src={ArrowFillIcon}
                      alt="list"
                      width={9}
                      height={9}
                    />
                  </div>
                  <div className={styles.coin_symbol}>
                    <p>{payCoin?.symbol}</p>
                  </div>
                  <div className={styles.coin_name}>
                    <span>{payCoin?.faName}</span>
                  </div>
                  <div className={styles.coin_pic}>
                    <img
                      src={`/images/assets-logo/${payCoin?.symbol}.png`}
                      alt={payCoin?.symbol}
                      width={23}
                      height={23}
                    />
                  </div>
                </div>
              </Paper>
            </div>
            <div className={` font_color_white ${styles.user_coin_info}`}>
              <div>
                <span>موجودی: </span>
                <span>
                  {coinOfUser && coinOfUser.balance - coinOfUser.locked}{" "}
                </span>
                <span>{payCoin?.faName}</span>
              </div>
              <div>پرداخت میکنید</div>
            </div>
          </div>
          <div className={styles.swap_coins}>
            <img
              src={SwitchIcon}
              alt="SWAP"
              width={30}
              height={30}
              onClick={() => changePayGet()}
            />
          </div>
          <div className={styles.get_coin_information}>
            <div
              className={`font_color_change_to_green ${styles.deposit_coin}`}
            >
              <div onClick={() => history.push(`/deposit/${getCoin?.symbol}`)}>
                واریز
                <img
                  src={CartIcon}
                  width={22}
                  height={22}
                  alt="cart"
                  className="convertPicToGreen"
                />
              </div>
            </div>
            <div className={` changeBackgroundToWhite ${styles.input_place}`}>
              <Paper
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div style={{ paddingLeft: "8px" }}>
                  <img src={EqualIcon} alt="" width={20} height={17} />
                </div>
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  disabled
                  readOnly
                  value={showPrice(orderAmount * rateValue)}
                />
                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                <div
                  className={styles.box_coin_select}
                  onClick={() => {
                    !disabledBtn && setCoinListVisible(true);
                    setForWhich(1);
                  }}
                >
                  <div className={styles.ArrowPlace}>
                    <img
                      className={styles.forAnim_arrow}
                      src={ArrowFillIcon}
                      alt="list"
                      width={9}
                      height={9}
                    />
                  </div>
                  <div className={styles.coin_symbol}>
                    <p>{getCoin?.symbol}</p>
                  </div>
                  <div className={styles.coin_name}>
                    <span>{getCoin?.faName}</span>
                  </div>
                  <div className={styles.coin_pic}>
                    <img
                      src={`/images/assets-logo/${getCoin?.symbol}.png`}
                      alt={getCoin?.symbol}
                      width={23}
                      height={23}
                    />
                  </div>
                </div>
              </Paper>
            </div>
            <div className={`font_color_white ${styles.user_coin_info}`}>
              <div></div>
              <div>دریافت میکنید</div>
            </div>
          </div>
          <div
            className={`changeBackgroundToWhite ${styles.convert_coins_price}`}
          >
            <div className={styles.left_right_side_coin}>
              <div className={styles.icon_mini_chart}>
                <img src={MiniChartIcon} alt="" width={15} height={15} />
              </div>
              <div
                className={`changeFontColorToBlack ${styles.price_of_one_coin}`}
              >
                <span>1</span>
                <span>{payCoin?.symbol}</span>
                <span> = </span>
              </div>
              <div
                className={`changeFontColorToBlack ${styles.dollar_price_of_coin}`}
              >
                <div>دلار</div>
                <div>
                  {!isEmpty(marketCoinsList) &&
                    showBetterPrice(
                      marketCoinsList?.filter(
                        (e) => e.symbol === payCoin.symbol
                      )[0]?.usdtPrice
                    )}
                </div>
              </div>
            </div>
            <div className={styles.line_between_price}></div>
            <div className={styles.left_right_side_coin}>
              <div className={styles.icon_mini_chart}>
                <img src={MiniChartIcon} alt="" width={15} height={15} />
              </div>
              <div
                className={`changeFontColorToBlack ${styles.price_of_one_coin}`}
              >
                <span>1</span>
                <span>{getCoin?.symbol}</span>
                <span> = </span>
              </div>
              <div
                className={`changeFontColorToBlack ${styles.dollar_price_of_coin}`}
              >
                <div>دلار</div>
                <div>
                  {!isEmpty(marketCoinsList) &&
                    showBetterPrice(
                      marketCoinsList?.filter(
                        (e) => e.symbol === getCoin.symbol
                      )[0]?.usdtPrice
                    )}
                </div>
              </div>
            </div>
          </div>
        </main>
        <footer className={styles.footer_convert}>
          <div className={styles.line_convert_footer}>
            <Slider
              aria-label="Temperature"
              valueLabelDisplay="auto"
              step={25}
              marks
              min={25}
              max={100}
              onChange={setUserBalanceValue}
            />
          </div>
          <div className={styles.showErrorNotification}>
            <img src={WarningRedIcon} alt="" width={25} height={25} />
            <div>
              حداقل مقدار تبدیل برای <span>{getCoin?.faName}</span> :‌{" "}
              <span>{showPrice(GET_COIN_INFO?.minAmount)}</span>
            </div>
          </div>
          <button
            type="submit"
            className={styles.button_convert}
            disabled={isEmpty(userId) ? true : disabledBtn}
            onClick={handleMakeOrders}
          >
            تبدیل
          </button>
          {isEmpty(userId) ? (
            <div className={styles.message_for_login}>
              ابتدا وارد{" "}
              <span onClick={() => history.push("/authorization/login")}>
                حساب کاربری
              </span>{" "}
              خود شوید
            </div>
          ) : (
            ""
          )}
        </footer>
      </div>
    </>
  );
}
